<template>
  <div>
    <header-status />

    <div class="conteudo" v-if="conversation">
      <div class="licao">
        <div class="conversation-capa">
          <h3>{{conversation.title}}</h3>
          <img :src="conversation.img" alt />
        </div>
        <div class="row">
          <div class="col-6">
            <div class="exercicios">
              <h3>{{conversation.actor_one}}</h3>

              <slick ref="slick" :options="slickOptions" v-if="actor_one.length">
                <div class="btn-q" v-for="(item, index) in actor_one" :key="index">
                  <div class="btn-responder" @click="getQuestion(item.id)">
                    <div class="numero">{{index+1}}</div>
                    <div v-if="resposta(item.id) == 0">
                      <div class="status fazer">Fazer agora</div>
                    </div>
                    <div v-if="resposta(item.id) == 1">
                      <div class="status refazer">Refazer</div>
                    </div>
                    <div v-if="resposta(item.id) == 2">
                      <div class="status feito">Feito</div>
                    </div>
                  </div>
                </div>
              </slick>
            </div>
            <div class="exercicios">
              <h3>{{conversation.actor_two}}</h3>

              <slick ref="slick" :options="slickOptions" v-if="actor_two.length">
                <div class="btn-q" v-for="(item, index) in actor_two" :key="index">
                  <div class="btn-responder" @click="getQuestion(item.id)">
                    <div class="numero">{{index+1}}</div>
                    <div v-if="resposta(item.id) == 0">
                      <div class="status fazer">Fazer agora</div>
                    </div>
                    <div v-if="resposta(item.id) == 1">
                      <div class="status refazer">Refazer</div>
                    </div>

                    <div v-if="resposta(item.id) == 2">
                      <div class="status feito">Feito</div>
                    </div>
                  </div>
                </div>
              </slick>
            </div>
          </div>
          <div class="col-6">
            <div class="resolucoes">
              <div v-if="question">
                <div class="topo">
                  <div class="ordem">{{question.order}}</div>
                  <div class="text">
                    <div class="title">{{question.answer}}</div>
                    <div class="sub-tile">{{question.translate}}</div>
                  </div>

                  <div class="ouvir" @click="showSom()" v-if="!ouvir">
                    <a>
                      <v-icon>fas fa-volume-up</v-icon>
                      <br />Ouvir
                    </a>
                  </div>
                  <div class="audio" v-if="ouvir">
                    <audio :src="question.audio" preload="auto" controls></audio>
                  </div>

                  <div class="gravar" :class="{'blink': txt_gravar == 'Gravando'}" @click="start()">
                    <v-icon :class="{'blink': txt_gravar == 'Gravando'}" >fas fa-microphone-alt</v-icon>
                    <br />
                    <span :class="{'blink': txt_gravar == 'Gravando'}">{{txt_gravar}}</span>
                  </div>
                  {{fala}}
                  <div
                    class="btn-next"
                    @click="verificar(question.id,fala,question.answer)"
                  >Responder</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--row-->
      </div>
    </div>

    <footer-page />
    <v-dialog v-model="dialogResp" width="400px">
      <v-card>
        <v-card-title style="text-align: center;">
          <span class="headline" v-if="status == 'hit'">PARABÉNS VOCÊ ACERTOU!</span>
          <span class="headline" v-else>RESPOSTA INCORRETA!</span>
        </v-card-title>
        <v-card-text style="text-align: center;">
          <v-icon color="green" size="80" v-if="status == 'hit'">fas fa-check-circle</v-icon>
          <v-icon color="red" size="80" v-else>fas fa-times-circle</v-icon>
          <div v-if="status == 'hit' && question.translate">
            TRADUÇÃO
            <br />
            {{question.translate}}
          </div>

          <div v-if="status == 'missed'">
            <v-btn color="primary" text @click="showAnswer = true">VER RESPOSTA</v-btn>
            <br />
            <div v-if="showAnswer">{{question.answer}}</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogResp = false; showAnswer = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { authService } from "../plugins/firebase";
import Slick from "vue-slick";
export default {
  components: { Slick },
  data() {
    return {
      dialogResp: false,
      showAnswer: false,
      status: null,
      txt_gravar: "Gravar",
      ouvir: null,
      conversation: null,
      respostas: [],
      question: null,
      recognition: "",
      fala: "",
      actor_one: {},
      actor_two: {},
      slickOptions: {
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 2,
        nextArrow: '<img src="http://hoomweb.com/img/next.png" class="next">',
        prevArrow: '<img src="http://hoomweb.com/img/prev.png" class="prev">'
      }
    };
  },

  created() {
    if (CONVERSATION) {
      this.conversation = CONVERSATION.find(
        o => o.id == this.$route.params.conversation
      );
      console.log("this.conversation", this.conversation);
      this.getRespostas();
      this.getListActors();
    } else {
      window.location.href = "/home";
    }
  },
  methods: {
    getListActors() {
      const arr_one = [];
      const arr_two = [];
      this.conversation.conversation_audios.forEach(obj => {
        if (obj.actor == "actor_one") {
          arr_one.push(obj);
        } else {
          arr_two.push(obj);
        }
      });
      this.actor_one = arr_one;
      this.actor_two = arr_two;
    },
    resposta(id) {
      if (!this.respostas) return 0;
      var status = 0;
      this.respostas.forEach(obj => {
        if (id == obj.conversation_audio_id) {
          if (obj.status == "missed") {
            status = 1;
          } else {
            status = 2;
          }
        }
      });
      return status;
    },
    getQuestion(id) {
      this.conversation.conversation_audios.forEach(obj => {
        if (id == obj.id) {
          this.question = obj;
          this.fala = "";
          this.ouvir = null;
        }
      });
      return true;
    },
    showSom() {
      this.ouvir = true;
      return true;
    },
    async getRespostas() {
      let config = {
        headers: {
          Authorization: "Bearer " + (await authService.validToken())
        }
      };
      this.$http
        .get(SERVE + "/students/conversation_myactivities", config)
        .then(objs => {
          this.respostas = objs.data;
        });
    },
    start() {
      this.txt_gravar = "Gravando";
      var SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;
      this.recognition = new SpeechRecognition();
      this.fala = "";

      this.recognition.lang = "en-US";
      this.recognition.onresult = event => {
        var current = event.resultIndex;

        var transcript = event.results[current][0].transcript;

        var mobileRepeatBug =
          current == 1 && transcript == event.results[0][0].transcript;

        if (!mobileRepeatBug) {
          this.fala += transcript;
          if (this.fala) {
            this.txt_gravar = "Gravar";
          }
          //
        }
      };
      this.recognition.start();
    },

    verificar(question_id, answer, check) {
      if (!answer || answer.trim() == "") return alert("Responda a Questão");
      var status = "missed";
      //answer = answer.toUpperCase();

      if (this.normalizeText(answer) == this.normalizeText(check)) {
        var status = "hit";
        //alert("Resposta Certa !!!");
      } else {
        //alert("Resposta Errada !!!");
      }

      this.status = status;
      this.dialogResp = true;

      this.responder(question_id, answer, status);
    },
    normalizeText(t) {
      t = t.normalize("NFD");
      t = t.replace(/\s\s+/g, " ");
      t = t.replace(/[0-9/,?!.:' ` ‘ ’]/g, "");
      t = t.toLowerCase();
      return t;
    },
    async responder(question_id, answer, status) {
      const params = {
        id: USER_ID,
        conversation_audio_id: question_id,
        status: status,
        answer: answer
      };

      let config = {
        headers: {
          Authorization: "Bearer " + (await authService.validToken())
        }
      };
      this.$http
        .post(SERVE + "/students/conversation_activities", params, config)
        .then(response => {
          this.getRespostas();
        });
    },
    next() {
      this.$refs.slick.next();
    },
    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        $(this.$el)[0].slick("refresh");
      });
    }
  }
};
</script>
